import React, { useState } from 'react';
import {
  IconButton,
  Tooltip,
  Typography,
  Box,
  Popover
} from '@mui/material';
import { NotificationsActive as NotificationsActiveIcon } from '@mui/icons-material';
import { getNoteBellColor } from '../../utils/noteBellColors';

function NotePreviewContent({ note, senderName }) {
  return (
    <Box sx={{ maxWidth: 320 }}>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
        {note || 'Nessun testo'}
      </Typography>
      {senderName && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Da: {senderName}
        </Typography>
      )}
    </Box>
  );
}

const MaintenanceNoteBell = ({ maintenance }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const color = getNoteBellColor(maintenance.noteSentByUserId);
  const note = maintenance.privateNotes || '';
  const senderName = maintenance.noteSentBy?.name;

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip
        title={<NotePreviewContent note={note} senderName={senderName} />}
        arrow
        placement="top"
        enterDelay={300}
        componentsProps={{
          tooltip: {
            sx: { maxWidth: 360 }
          }
        }}
      >
        <IconButton
          size="small"
          onClick={handleClick}
          aria-label="Leggi nota privata"
          sx={{ p: 0.25, mr: 0.25 }}
        >
          <NotificationsActiveIcon fontSize="small" sx={{ color }} />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box sx={{ p: 2, maxWidth: 360 }}>
          <NotePreviewContent note={note} senderName={senderName} />
        </Box>
      </Popover>
    </>
  );
};

export default MaintenanceNoteBell;
